/**
 * All items available for every kind of users
 * @module
 */

import React from 'react';

const groomerIconWhite = require('./images/groomerWhite.svg');

export default [
  {
    paneName: 'myaccount',
    icon: <i className="mi mi-settings"/>,
    admin: false
  },
  {
    paneName: 'quicksend',
    icon: <i className="mi mi-sms"/>,
    admin: true
  },
  {
    paneName: 'editskiresort',
    icon: <i className="mi mi-edit"/>,
    admin: true
  },
  {
    paneName: 'editgroomers',
    icon: <img src={groomerIconWhite} style={{width: 31, position: 'relative', top: '4px'}}/>,
    admin: true
  },
  {
    paneName: 'addskiresort',
    icon: <i className="mi mi-add"/>,
    admin: true
  },
  {
    paneName: 'editaccounts',
    icon: <i className="mi mi-people"/>,
    admin: true
  }
];



// WEBPACK FOOTER //
// ./src/menuItems.js